<template>
  <div>
    <QuickFixDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      isCardColor="true"
      @register="register"
    >
      <template v-slot:[pageData[0].name]>
        <div class="px-7">
          <v-container fluid>
            <v-row no-gutters class="pa-1">
              <v-col cols="6">
                <InputFormNew
                  v-model="pageInfoData.line1"
                  :detail="pageInfoDetail.line1"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                </InputFormNew>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
    </QuickFixDialogBase>
  </div>
</template>
<script>
import QuickFixDialogBase from './QuickFixDialogBase'

import headers from '@/views/order/Loading/headers'
import InputFormNew from '@/components/items/Designs/InputFormNew'
import { mapActions } from 'vuex'

export default {
  components: {
    QuickFixDialogBase,
    InputFormNew
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    },
    pageInfoData: {}
  },
  data: () => ({
    pageData: [],

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },
    pageInfoDetail: {
      line1: [
        {
          name: 'controlNumber',
          text: 'loading.loading_loading-number',
          component: 'text'
        },
        {
          name: 'spplierName',
          text: 'product.product_supplier',
          component: 'text'
        },
        {
          name: 'storageName',
          text: 'loading.loading_loading-storage',
          component: 'text'
        },
        {
          name: 'loadingDate',
          text: 'loading.loading_loading-date',
          component: 'text'
        },
        {
          name: 'remarks',
          text: 'common.input_remarks',
          textPositionStart: true,
          component: 'Remarks'
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Loading', ['editLoading']),
    ini() {
      this.pageData = [
        {
          title: 'loading.loading_loading-info',
          name: 'loadingInfo',
          items: [],
          itemKey: ''
        },
        {
          title: 'order.loading_loading-product',
          name: 'loadingProduct',
          productHeaders: headers.productListHeaders,
          itemKey: headers.tableKey,
          items: this.recItems.productMoves
        }
      ]
    },
    async register() {
      const isSucceed = await this.editLoading({
        pageInfoData: this.pageInfoData,
        id: this.recItems.loadingId
      })
      if (isSucceed) {
        this.inputedValue.dialog = false
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
